import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const paxCombinationReducer = (state = {}, action) => {
  switch (action.type) {
    case types.RATE_SELECTED:
    case types.DEAL_RATE_SELECTED: {
      const { rateId, roomId } = action.payload;
      return {
        ...state,
        rateId,
        roomId
      };
    }

    default:
      return state;
  }
};

export const paxListReducer = (state = initialState.paxList, action) => {
  switch (action.type) {
    case types.PAX_LOADED:
      return [...action.payload];

    // case types.SET_SEARCH_DATA:
    //   return (action.payload && action.payload.Pax) || initialState.paxList;

    case types.RATE_SELECTED:
    case types.DEAL_RATE_SELECTED: {
      const { RequestDescriptor } = action.payload;
      const nextState = state.map(pax => {
        if (pax.id != RequestDescriptor) return pax;
        return paxCombinationReducer(pax, action);
      });
      return nextState;
    }
    case types.RESET_RATE_SELECTION:
    case types.SELECTION_RESET:
    case types.DEAL_RATE_UNSELECTED: {
      const nextState = state.map(pax => {
        return { ...pax, rateId: null, roomId: null };
      });
      return nextState;
    }

    case types.PAX_REMOVED: {
      const { paxId } = action.payload;
      const nextPax = state.filter(px => px.id !== paxId);
      return nextPax;
    }

    case types.SET_SEARCH_DATA:
      return (action.payload && action.payload.Pax) || initialState.paxList;

    case types.RESET_PAX_LIST:
      return state;

    default:
      return state;
  }
};

export const selectedPaxIdReducer = (
  state = initialState.selectedPaxId,
  action
) => {
  switch (action.type) {
    case types.SELECTED_PAX_INDEX_CHANGE:
      return action.payload;
    case types.DEAL_RATE_SELECTED: {
      if (
        action.payload.dealSearchResults &&
        action.payload.dealSearchResults.length >
          action.payload.RequestDescriptor + 1
      ) {
        return action.payload.RequestDescriptor + 1;
      } else {
        return action.payload.RequestDescriptor;
      }
    }
    case types.RESET_SELECTED_PAX_INDEX:
    case types.SELECTION_RESET:
    case types.SET_SEARCH_DATA:
      return initialState.selectedPaxId;
    default:
      return state;
  }
};

export const singlePaxLoadedReducer = (
  state = initialState.singlePaxLoaded,
  action
) => {
  switch (action.type) {
    case types.PAX_LOADED: {
      const nextState = action.payload.length == 1;
      return nextState;
    }
    case types.SET_SEARCH_DATA: {
      const nextState = action.payload && action.payload.Pax == 1;
      return nextState;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/paxReducer.js